module.exports = __webpack_public_path__ + "img/c9.30dd5203.png";